var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('embed',{attrs:{"src":(_vm.publicPath + "/pdf/" + _vm.fileName + ".pdf"),"type":"application/pdf","width":"100%","height":"100%"}})}
var staticRenderFns = []

export { render, staticRenderFns }